import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { CODE_COLUMN_WIDTH, COLUMN_GAP, FIELD_LABEL_HEIGHT, boxBase } from './layout';

/** Wide bold box next to the code with the selected customer / address name. */
const NameBox = styled.div`
  ${boxBase};
  margin-top: ${FIELD_LABEL_HEIGHT};
  font-weight: 700;
  text-transform: uppercase;

  ${mediaMinWidth.sm(css`
    margin-top: 0;
  `)};
`;

const DetailList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-top: 0.6rem;
`;

const DetailRow = styled.div`
  display: grid;
  grid-template-columns: ${CODE_COLUMN_WIDTH} minmax(0, 1fr);
  column-gap: ${COLUMN_GAP};
  align-items: center;

  ${mediaMinWidth.sm(css`
    grid-template-columns: minmax(0, 1fr);
    row-gap: 0.2rem;
  `)};
`;

const DetailLabel = styled.span`
  font-family: 'LFT Zeno', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${pickColor('grayDark')};
  text-align: right;

  ${mediaMinWidth.sm(css`
    text-align: left;
  `)};
`;

const DetailValue = styled.div`
  ${boxBase};
`;

const DetailMuted = styled.p`
  margin: 0;
  padding-top: 0.6rem;
  margin-left: calc(${CODE_COLUMN_WIDTH} + ${COLUMN_GAP});
  font-size: 1.2rem;
  font-family: 'LFT Zeno', sans-serif;
  color: ${pickColor('grayDark')};
  font-style: italic;

  ${mediaMinWidth.sm(css`
    margin-left: 0;
  `)};
`;

export { DetailLabel, DetailList, DetailMuted, DetailRow, DetailValue, NameBox };
